// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"0c384949","330":"90a0cd6c","361":"b498ac97","392":"6a3cc069","421":"c260eebf","542":"171a0a77","543":"e67251c9","680":"69039172","787":"d2e7dd87","827":"096bba06","873":"293659c6","875":"fd306f6a","937":"eab44e09","955":"dbc7148e"}[chunkId] + ".chunk.js";
};